<template>
  <div>
    <datepicker-input
      v-model="vehicleForm.requested_start_date"
      label="Requested Start Date"
      helper="Please enter the date the client requested the hire to begin"
    ></datepicker-input>

    <datepicker-input
      v-model="vehicleForm.start_date"
      label="Hire Start Date"
      helper="Please enter the date the hire will start"
    ></datepicker-input>

    <!--    <datepicker-input-->
    <!--      v-model="vehicleForm.requested_end_date"-->
    <!--      label="Requested End Date"-->
    <!--      helper="Please enter the date the client requested the hire to end"-->
    <!--    ></datepicker-input>-->

    <datepicker-input
      v-model="vehicleForm.end_date"
      label="Hire End Date"
      helper="If known, please enter the date the hire will end"
    ></datepicker-input>

    <!--    <datepicker-input-->
    <!--      v-model="vehicleForm.last_chargeable_date"-->
    <!--      label="Last Chargeable Date"-->
    <!--      helper="If known, please enter the last chargeable date"-->
    <!--    ></datepicker-input>-->

    <fieldset>
      <legend>
        Delivery Address
        <button
          class="btn btn-primary btn-sm float-right"
          v-on:click.prevent="copyClientAddress"
        >
          Copy Client Address
        </button>
      </legend>

      <address-lookup
        :address="address"
        v-on:address="setAddress"
      ></address-lookup>
    </fieldset>

    <fieldset>
      <legend>Reason For Hire</legend>
      <textarea
        class="form-control"
        name="hire_reason"
        rows="3"
        placeholder="Please specify why the hire is needed"
        v-model="details.hire_reason"
      ></textarea>
    </fieldset>
  </div>
</template>
<script>
export default {
  props: {
    details: {
      type: Object,
      required: true
    },
    vehicleForm: {
      type: Object,
      required: true
    }
  },

  computed: {
    client() {
      return this.$store.getters['Incident/client'];
    },

    address() {
      return {
        address_line_one: this.details?.address_line_one,
        address_line_two: this.details?.address_line_two,
        city: this.details?.city,
        postcode: this.details?.postcode
      };
    }
  },

  methods: {
    setStartDate(date) {
      this.vehicleForm.start_date = date;
    },

    copyClientAddress() {
      this.details.address_line_one = this.client?.address_line_one;
      this.details.address_line_two = this.client?.address_line_two;
      this.details.city = this.client?.city;
      this.details.postcode = this.client?.postcode;
    },

    setAddress(address) {
      this.details.address_line_one = address.address_line_one;
      this.details.address_line_two = address.address_line_two;
      this.details.city = address.city;
      this.details.postcode = address.postcode;
    },

    emitChanged() {
      this.$emit('changed');
    }
  }
};
</script>
